import React from 'react';

export default function PadreNuestro() {
  return (
    <>
    <p>
    Padre nuestro que estás en el cielo, <br/> santificado sea tu Nombre; <br/> venga a nosotros tu Reino; <br/> hágase tu voluntad <br/> en la tierra como en el cielo. <br/> Danos hoy nuestro pan de cada día; <br/> perdona nuestras ofensas, <br/> como también nosotros perdonamos a los que nos ofenden; <br/> no nos dejes caer en la tentación, <br/> y líbranos del mal. <br/> <br/> Amén.
    </p>
    </>
  );
}
